import { Box, Heading, Text, Image,HStack, Flex, SimpleGrid } from '@chakra-ui/react';
import PublicLayout from "./Layouts/PublicLayout"
import PrivacyPolicy from "../../Components/PrivacyPolicy"

const B2CPrivacyPolicy = () => (
  <PublicLayout>
      <Box p={4} >
        <PrivacyPolicy />
      </Box>
  </PublicLayout>
);

export default B2CPrivacyPolicy;